import styled from 'styled-components';
import tw from 'twin.macro';

export const Dialog = styled.div(() => [
  tw`flex items-center justify-center flex-col relative h-full p-32 max-h-full`
]);

export const DialogContent = styled.div(() => [
  tw`bg-white rounded relative overflow-y-auto flex flex-col p-20 items-center max-h-full`,
  'transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
  'box-shadow: rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px;',
  'max-width: 500px;'
]);
